import { View, type ViewProps } from 'react-native';

export type ThemedViewProps = ViewProps & {
  className?: string;
};

export function ThemedView({ className = '', ...rest }: ThemedViewProps) {
  return <View className={`bg-parchment dark:bg-navy ${className}`} {...rest} />;
}
